import { useEffect } from 'react';
import PublicPortalRoutes from './routes/PublicPortalRoutes';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { usePageTracking } from '@/shared/hooks/usePageTracking';
import { CookieConsentBanner } from '@/features/cookie-consent';

function App() {
  usePageTracking();

  // Scroll to top on route change
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Lazy load toast CSS — only needed when a toast appears
  useEffect(() => {
    import('react-toastify/dist/ReactToastify.css');
  }, []);

  return (
    <>
      <Routes>
        <Route path='/*' element={<PublicPortalRoutes />} />
      </Routes>
      <ToastContainer limit={5} />
      <CookieConsentBanner />
    </>
  );
}

export default App;
